import { useQuery } from '@tanstack/react-query';

import { queries } from '../../../../queries';
import { useAPIErrorHandler } from '../../useAPIErrorHandler';

export function usePolicies(filters: Record<string, unknown>, enabled = true) {
  const handleAPIError = useAPIErrorHandler();

  return useQuery({
    ...queries.policies.list(filters),
    keepPreviousData: true,
    onError: handleAPIError('Unable to fetch policies'),
    select: (data) => ({
      policies: data.content,
      totalCount: data.totalElements,
    }),
    enabled,
  });
}
